import { useContext } from 'react';
import { ZoomContext } from '../components/ZoomProvider';

export const useZoom = () => {
  const zoomClient = useContext(ZoomContext);
  return { zoomClient };
};
